export const getURLName = (name: string): string => {
    return  name ? name.toLowerCase().replace(/- /g, "").replace(/ /g, "-") : "";
}